export const paIN = {
  ANSWER: {
    CARRIER: {
      "3PL": "3PL",
      BREAD: "ਰੋਟੀ",
      COKE: "ਕੋਕ",
      DSD: "DSD",
      FLOWERS: "ਫੁੱਲ",
      GFS: "GFS",
      LCL: "LCL",
      MEAT: "ਮੀਟ",
      PEPSI: "ਪੈਪਸੀ",
    },
    DRIVER_TYPE: {
      CONTRACTOR: "ਠੇਕੇਦਾਰ",
      DELIVERY: "ਡਿਲੀਵਰੀ",
      FLEET_DRIVER: "ਫਲੀਟ ਡਰਾਈਵਰ",
      GULFSTREAM: "ਗਲਫਸਟ੍ਰੀਮ",
      MAINTENANCE: "ਰੱਖ-ਰਖਾਅ",
      PERSONAL_VEHICLE: "ਨਿੱਜੀ ਵਾਹਨ",
      SERVICE: "ਸੇਵਾ",
      SHUNT_DRIVER: "ਸ਼ੰਟ ਡਰਾਈਵਰ",
      SHUTTLE_DRIVER: "ਸ਼ਟਲ ਡਰਾਈਵਰ",
    },
    DUNNAGE: {
      "1_2": "1/2",
      "1_4": "1/4",
      FULL: "ਪੂਰਾ",
    },
    ENTRY_PURPOSE: {
      BOBTAIL: "ਬੌਬਟੇਲ",
      CARRIER_LOADED: "ਕੈਰੀਅਰ ਲੋਡ ਕੀਤਾ ਗਿਆ",
      CONTRACTOR: "ਠੇਕੇਦਾਰ",
      CONTRACTOR_VISITOR: "ਠੇਕੇਦਾਰ/ਵਿਜ਼ਿਟਰ",
      DELIVERY: "ਡਿਲੀਵਰੀ",
      DROP: "ਡ੍ਰੌਪ",
      DROP_HOOK: "ਡ੍ਰੌਪ ਹੁੱਕ",
      EMPTY: "ਖਾਲੀ",
      EMPTY_TRAILER: "ਖਾਲੀ ਟ੍ਰੇਲਰ",
      FOODBANK: "ਫੂਡਬੈਂਕ",
      FUEL: "ਇੰਧਨ",
      LIVE_LOAD: "ਲਾਈਵ ਲੋਡ",
      LOADED: "ਲੋਡ ਕੀਤਾ ਗਿਆ",
      NFI_LOADED: "NFI ਲੋਡ ਕੀਤਾ ਗਿਆ",
      OTHERS: "ਹੋਰ",
      PARKING: "ਪਾਰਕਿੰਗ",
      PICKUP_EMPTY: "ਪਿਕਅੱਪ ਖਾਲੀ",
      PICKUP_LOAD: "ਪਿਕਅੱਪ ਲੋਡ",
      PICK_UP: "ਪਿਕਅੱਪ",
      PLANT_LOADED: "ਪਲਾਂਟ ਲੋਡ ਕੀਤਾ ਗਿਆ",
      PRIVATE: "ਨਿੱਜੀ",
      REPAIR: "ਮੁਰੰਮਤ",
      VISITOR: "ਵਿਜ਼ਿਟਰ",
      WAAS_FAAS: "WAAS/FAAS",
      WASH: "ਧੋਣਾ",
    },
    ENTRY_TYPE: {
      INBOUND: "ਇਨਬਾਊਂਡ",
      INBOUND_ARRIVAL: "ਇਨਬਾਊਂਡ/\r\nਆਉਣ ਵਾਲਾ",
      INBOUND_DROP: "ਇਨਬਾਊਂਡ / ਡ੍ਰੋਪ",
      MAINTENANCE: "ਰੱਖ-ਰਖਾਅ",
      OUTBOUND: "ਆਊਟਬਾਊਂਡ",
      OUTBOUND_DEPARTURE: "ਆਊਟਬਾਊਂਡ/\r\nਰਵਾਨਗੀ",
      OUTBOUND_PICKUP: "ਆਊਟਬਾਊਂਡ / ਪਿਕਅੱਪ",
      WALMART_CARRIERS: "ਵਾਲਮਾਰਟ ਕੈਰੀਅਰ",
      YARD_STORAGE: "ਯਾਰਡ ਸਟੋਰੇਜ",
    },
    EQUIPMENT_LENGTH: {
      "20": "20",
      "40": "40",
      "48": "48",
      "53": "53",
    },
    EQUIPMENT_TYPE: {
      BOBTAIL: "ਬੌਬਟੇਲ",
      CHASSIS: "ਚੈਸੀ",
      CONTAINER: "ਕੰਟੇਨਰ",
      TRAILER: "ਟ੍ਰੇਲਰ",
      VAN: "ਵੈਨ",
    },
    FUEL_LEVEL: {
      "1_2": "1/2",
      "1_4": "1/4",
      "1_8": "1/8",
      "3_4": "3/4",
      "3_8": "3/8",
      "5_8": "5/8",
      "7_8": "7/8",
      EMPTY: "ਖਾਲੀ",
      FULL: "ਪੂਰਾ",
    },
    GENERIC: {
      NO: "ਨਹੀਂ",
      YES: "ਹਾਂ",
    },
    LOADED_STATUS: {
      EMPTY: "ਖਾਲੀ",
      LOADED: "ਲੋਡ ਕੀਤਾ ਗਿਆ",
    },
    LOAD_DETAILS: {
      CONVERTER_1X: "CONVERTER_1X",
      CONVERTER_2X: "CONVERTER_2X",
      DRY: "ਸੁੱਕਾ",
      FROZEN: "ਜੰਮਿਆ",
      HEAT: "ਗਰਮੀ",
      "MULTI TEMP": "ਬਹੁ-ਤਾਪਮਾਨ",
      REEFER: "ਰੀਫਰ",
    },
    LOAD_TYPE: {
      BOBTAIL: "ਬੌਬਟੇਲ",
      EMPTY: "ਖਾਲੀ",
      LOADED: "ਲੋਡ ਕੀਤਾ ਗਿਆ",
      OTHERS: "ਹੋਰ",
    },
    REEFER: {
      OFF: "ਬੰਦ",
      ON: "ਚਾਲੂ",
    },
    TRAILER_TYPE: {
      DRY: "ਸੁੱਕਾ",
      REEFER: "ਰੀਫਰ",
    },
    VISIT_TYPE: {
      DROP_AND_GO: "ਡ੍ਰੌਪ ਐਂਡ ਗੋ",
      DROP_AND_WAIT: "ਡ੍ਰੌਪ ਐਂਡ ਵੇਟ",
      DROP_EMPTY: "ਡ੍ਰੌਪ ਖਾਲੀ",
      PICKUP_EMPTY: "ਪਿਕਅੱਪ ਖਾਲੀ",
    },
  },
  APP: {
    DEVELOPED_BY_EAIGLE: "EAIGLE ਦੁਆਰਾ ਵਿਕਸਤ ਕੀਤਾ ਗਿਆ",
    INVALID_FACILITY: "ਸਹੂਲਤ ਨਹੀਂ ਮਿਲੀ!",
    PAGE_NOT_FOUND: "ਪੰਨਾ ਨਹੀਂ ਮਿਲਿਆ। ਅਵੈਧ ਪੈਰਾਮੀਟਰ",
    PLEASE_ROTATE:
      "ਇਸ ਐਪਲੀਕੇਸ਼ਨ ਦੀ ਵਰਤੋਂ ਕਰਨ ਲਈ ਕਿਰਪਾ ਕਰਕੇ ਆਪਣੇ ਡਿਵਾਈਸ ਨੂੰ ਪੋਰਟਰੇਟ ਮੋਡ ਵਿੱਚ ਘੁੰਮਾਓ।",
    POWERED_BY_EAIGLE: "<LOGO/> eaagle.com ਦੁਆਰਾ ਸੰਚਾਲਿਤ",
  },
  AVAC: {
    ADD_COMMENT_HEADER: "ਟਿੱਪਣੀ ਸ਼ਾਮਲ ਕਰੋ (ਲੋੜੀਂਦਾ)",
    AREA: {
      ISO: "ISO",
      TANK_WASH: "ਟੈਂਕ ਨੂੰ ਧੋਣਾ",
    },
    COMMENT_HERE: "ਆਪਣੀ ਟਿੱਪਣੀ ਇੱਥੇ ਸ਼ਾਮਲ ਕਰੋ...",
    COMMENT_SUBMITTED: "ਟਿੱਪਣੀ ਸਬਮਿਟ ਕੀਤੀ ਗਈ",
    DETAILS: {
      ACTUAL_TEMPERATURE: "ਅਸਲ ਤਾਪਮਾਨ",
      ADDITIONAL_COMMENTS: "ਵਾਧੂ ਟਿੱਪਣੀਆਂ",
      ALLOCATED_PAD: "ਅਲਾਟ ਕੀਤਾ ਗਿਆ PAD",
      APPOINTMENT_INFORMATION: "ਅਪੌਇੰਟਮੈਂਟ ਦੀ ਜਾਣਕਾਰੀ",
      APPOINTMENT_NUMBER: "ਅਪੌਇੰਟਮੈਂਟ ਨੰਬਰ",
      APPOINTMENT_TIME: "ਅਪੌਇੰਟਮੈਂਟ ਦਾ ਸਮਾਂ",
      APPOINTMENT_TYPE: "ਅਪੌਇੰਟਮੈਂਟ ਦੀ ਕਿਸਮ",
      AVAC_EVENT: "AVAC ਇਵੈਂਟ",
      BOL_NUMBER: "BOL ਨੰਬਰ",
      BOOKING_NUMBER: "ਬੁਕਿੰਗ ਨੰਬਰ",
      BRE_STATUS: "BRE ਸਥਿਤੀ",
      BROKER: "ਦਲਾਲ",
      CARRIER: "ਕੈਰੀਅਰ",
      CARRIER_NAME: "ਕੈਰੀਅਰ ਦਾ ਨਾਮ",
      CHASSIS_NUMBER: "ਚੈਸੀ ਨੰਬਰ",
      CHILD_SCAC: "ਚਾਈਲਡ SCAC",
      COMMENT: "ਟਿੱਪਣੀ",
      CVIP_DATE: "CVIP ਮਿਤੀ",
      CV_DETAILS: "CV ਵੇਰਵੇ",
      CV_EVENT_ID: "CV ਇਵੈਂਟ ID",
      DELIVERY_NOTE: "ਡਿਲੀਵਰੀ ਨੋਟ",
      DESCRIPTION: "ਵਰਣਨ",
      DRIVER_ENGAGEMENT_TIME: "ਡਰਾਈਵਰ ਇੰਗੇਜਮੈਂਟ ਸਮਾਂ (ਸਕਿੰਟਾਂ ਵਿੱਚ)",
      DRIVER_INFORMATION: "ਡਰਾਈਵਰ ਦੀ ਜਾਣਕਾਰੀ",
      DRIVER_NAME: "ਡਰਾਈਵਰ ਦਾ ਨਾਮ",
      DUNNAGE: "ਡੰਨੇਜ",
      ENTRY_SUBTYPE: "ਐਂਟਰੀ ਦੀ ਉੱਪ-ਕਿਸਮ",
      ENTRY_TYPE: "ਐਂਟਰੀ ਦੀ ਕਿਸਮ",
      EQUIPMENT_LENGTH: "ਉਪਕਰਨ ਦੀ ਲੰਬਾਈ",
      EQUIPMENT_LOADED_STATUS: "ਉਪਕਰਨ ਲੋਡ ਕਰਨ ਦੀ ਸਥਿਤੀ",
      EQUIPMENT_TYPE: "ਉਪਕਰਨ ਦੀ ਕਿਸਮ",
      EQUIPMENT_TYPE_ID: "ਉਪਕਰਨ ਦੀ ਕਿਸਮ  ਦੀ ID",
      EVENT_ID: "ਇਵੈਂਟ ID",
      EVENT_INFORMATION: "ਇਵੈਂਟ ਦੀ ਜਾਣਕਾਰੀ",
      EVENT_TIME: "ਇਵੈਂਟ ਦਾ ਸਮਾਂ",
      EVENT_TYPE: "ਇਵੈਂਟ ਦੀ ਕਿਸਮ",
      FAILURE_REASON: "ਅਸਫਲਤਾ ਦਾ ਕਾਰਨ",
      FIRST_NAME: "ਪਹਿਲਾ ਨਾਮ",
      FUEL_LEVEL: "ਇੰਧਨ ਦਾ ਪੱਧਰ",
      GATE_ENGAGEMENT_TIME: "ਗੇਟ ਇੰਗੇਜਮੈਂਟ ਸਮਾਂ (ਸਕਿੰਟਾਂ ਵਿੱਚ)",
      ID: "ID",
      IMAGES: "ਤਸਵੀਰਾਂ",
      LANE_ID: "ਲੇਨ ID",
      LANE_NAME: "ਲੇਨ ਦਾ ਨਾਮ",
      LAST_NAME: "ਆਖਰੀ ਨਾਮ",
      LIVE_DROP: "ਲਾਈਵ ਡ੍ਰੌਪ",
      LOAD_ID: "ਲੋਡ ID",
      LTL: "LTL",
      MC_NUMBER: "MC ਨੰਬਰ",
      OPERATOR_COMMENTS: "ਆਪਰੇਟਰ ਦੀਆਂ ਟਿੱਪਣੀਆਂ",
      ORDER_NUMBER: "ਸੀਰੀਅਲ ਨੰਬਰ",
      PARENT_SCAC: "ਮੁੱਖ SCAC",
      PHONE_NUMBER: "ਫ਼ੋਨ ਨੰਬਰ",
      PLATE_NUMBER: "ਪਲੇਟ ਨੰਬਰ",
      PO: "PO",
      PO_LOAD_DETAILS: "PO / ਲੋਡ ਦੇ ਵੇਰਵੇ",
      PO_NUMBER: "PO ਨੰਬਰ",
      RAIL_CARS: "ਰੇਲ ਕਾਰਾਂ",
      REFERENCE_NUMBER: "ਹਵਾਲਾ ਨੰਬਰ",
      SCAC: "SCAC",
      SEAL_NUMBER: "ਸੀਲ ਨੰਬਰ",
      SET_TEMPERATURE: "ਤਾਪਮਾਨ ਨਿਰਧਾਰਿਤ ਕਰੋ",
      SPOT_NUMBER: "ਸਪਾਟ ਨੰਬਰ",
      START_TIME: "ਸ਼ੁਰੂਆਤੀ ਸਮਾਂ",
      STATUS: "ਸਥਿਤੀ",
      TEMPERATURE: "ਤਾਪਮਾਨ",
      TIMESTAMP: "ਟਾਈਮਸਟੈਂਪ",
      TRACTOR_ID: "ਟਰੈਕਟਰ ਦੀ ID",
      TRACTOR_NUMBER: "ਟਰੈਕਟਰ ਦਾ ਨੰਬਰ",
      TRAILER: "ਟ੍ਰੇਲਰ",
      TRAILER_NUMBER: "ਟ੍ਰੇਲਰ ਨੰਬਰ",
      TRAILER_TYPE: "ਟ੍ਰੇਲਰ ਦੀ ਕਿਸਮ",
      TRUCK_INFORMATION: "ਟਰੱਕ ਦੀ ਜਾਣਕਾਰੀ",
      TRUCK_NUMBER: "ਟਰੱਕ ਦਾ ਨੰਬਰ",
      UNIT: "ਯੂਨਿਟ",
      UNIT_ID: "ਯੂਨਿਟ ID",
      UNIT_NUMBER: "ਯੂਨਿਟ ਦਾ ਨੰਬਰ",
      UNIT_TYPE: "ਯੂਨਿਟ ਦੀ ਕਿਸਮ",
      USDOT_NUMBER: "USDOT ਨੰਬਰ",
      VEHICLE_MEDIA: "ਵਾਹਨ ਮੀਡੀਆ",
      VIDEOS: "ਵੀਡੀਓ",
      WAC: "WAC",
      ZONE: "ਜ਼ੋਨ",
    },
    DRIVER_ASSIST: "ਡਰਾਈਵਰ ਸਹਾਇਤਾ",
    DRIVER_CREATED: "ਡਰਾਈਵਰ ਸਫਲਤਾਪੂਰਵਕ ਬਣਾਇਆ ਗਿਆ!",
    DRIVER_PIN: "ਡਰਾਈਵਰ ਦਾ ਪਿੰਨ:",
    DRIVER_QR_CODE: "ਡਰਾਈਵਰ ਦਾ QR ਕੋਡ",
    DRIVER_UPDATED: "ਡਰਾਈਵਰ ਸਫਲਤਾਪੂਰਵਕ ਅੱਪਡੇਟ ਕੀਤਾ ਗਿਆ!",
    ERROR: {
      ACCESS_DENIED: "ਪਹੁੰਚ ਤੋਂ ਮਨਾਹੀ ਕੀਤੀ ਗਈ",
      ACCESS_DENIED_DETAILS: "ਤੁਹਾਡੇ ਕੋਲ ਇਸ ਮੋਡੀਊਲ ਤੱਕ ਪਹੁੰਚ ਨਹੀਂ ਹੈ।",
      AUTH_ERROR: "ਪ੍ਰਮਾਣੀਕਰਨ ਐਰਰ: {{ERROR}}",
      CONTACT_ADMIN: "ਕਿਰਪਾ ਕਰਕੇ ਇਜਾਜ਼ਤ ਲਈ ਆਪਣੇ ਐਡਮਿਨਿਸਟਰੇਟਰ ਨਾਲ ਸੰਪਰਕ ਕਰੋ।",
      ERROR_CREATING_DRIVER: "ਡਰਾਈਵਰ ਬਣਾਉਣ ਦੌਰਾਨ ਇੱਕ ਐਰਰ ਹੋਈ ਹੈ।",
      ERROR_UPDATING_DRIVER: "ਡਰਾਈਵਰ ਨੂੰ ਅੱਪਡੇਟ ਕਰਨ ਦੌਰਾਨ ਇੱਕ ਐਰਰ ਹੋਈ ਹੈ।",
      FAILED_TO_CREATE_DRIVER: "ਡਰਾਈਵਰ ਬਣਾਉਣ ਵਿੱਚ ਅਸਫਲ ਰਿਹਾ",
      FAILED_TO_FETCH_FACILITIES: "ਵਿਸ਼ੇਸ਼ਤਾਵਾਂ ਪ੍ਰਾਪਤ ਕਰਨ ਵਿੱਚ ਅਸਫਲ ਰਿਹਾ",
      FAILED_TO_UPDATE_DRIVER: "ਡਰਾਈਵਰ ਨੂੰ ਅੱਪਡੇਟ ਕਰਨ ਵਿੱਚ ਅਸਫਲ ਰਿਹਾ",
      LOADING_EVENT_DETAILS_AVAC:
        "ਇਵੈਂਟ ਵੇਰਵਿਆਂ ਨੂੰ ਲੋਡ ਕਰਨ ਵਿੱਚ ਐਰਰ। AVAC ਵੱਲ ਰੀਡਾਇਰੈਕਟ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ...",
      LOADING_EVENT_DETAILS_GATE_LOG:
        "ਇਵੈਂਟ ਵੇਰਵਿਆਂ ਨੂੰ ਲੋਡ ਕਰਨ ਵਿੱਚ ਐਰਰ। ਗੇਟ ਲੌਗ ਵੱਲ ਰੀਡਾਇਰੈਕਟ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ...",
      MISSING_EMAIL_AND_PHONE_NUMBER: "ਕਿਰਪਾ ਕਰਕੇ ਇੱਕ ਈਮੇਲ ਪਤਾ ਜਾਂ ਫ਼ੋਨ ਨੰਬਰ ਪ੍ਰਦਾਨ ਕਰੋ",
      NO_FACILITY_SELECTED: "ਕੋਈ ਸਹੂਲਤ ਨਹੀਂ ਚੁਣੀ ਗਈ",
      WEBSOCKET_ERROR: "ਵੈੱਬਸਾਕੇਟ ਐਰਰ: {{ERROR}}",
    },
    FACILITY: "ਸਹੂਲਤ",
    FAILED_EVENTS: "ਅਸਫਲ ਈਵੈਂਟਸ",
    HISTORICAL_EVENTS: "ਇਤਿਹਾਸਕ ਈਵੈਂਟਸ (ਆਖਰੀ ਦਿਨ)",
    IMAGE_MODAL_INSTRUCTIONS:
      "ਜ਼ੂਮ ਕਰਨ ਲਈ ਸਕ੍ਰੌਲ ਕਰੋ • ਜ਼ੂਮ ਕਰਨ ਤੋਂ ਬਾਅਦ ਪੈਨ ਕਰਨ ਲਈ ਡਰੈਗ ਕਰੋ",
    NEW_DRIVER: {
      PIN_SENT: "ਪਿੰਨ ਡਰਾਈਵਰ ਦੇ ਈਮੇਲ ਅਤੇ ਫ਼ੋਨ ਨੰਬਰ 'ਤੇ ਭੇਜ ਦਿੱਤਾ ਗਿਆ ਹੈ।",
      QR_CODE_AND_PIN_SENT:
        "QR ਕੋਡ ਅਤੇ ਪਿੰਨ ਡਰਾਈਵਰ ਦੇ ਈਮੇਲ ਅਤੇ ਫ਼ੋਨ ਨੰਬਰ 'ਤੇ ਭੇਜ ਦਿੱਤਾ ਗਿਆ ਹੈ।",
      QR_CODE_SENT: "QR ਕੋਡ ਡਰਾਈਵਰ ਦੇ ਈਮੇਲ ਅਤੇ ਫ਼ੋਨ ਨੰਬਰ 'ਤੇ ਭੇਜ ਦਿੱਤਾ ਗਿਆ ਹੈ।",
    },
    NO_APPROVED_EVENTS: "ਚੁਣੀ ਗਈ ਮਿਤੀ ਸੀਮਾ ਲਈ ਕੋਈ ਮਨਜ਼ੂਰੀਸ਼ੁਦਾ ਇਵੈਂਟ ਨਹੀਂ ਮਿਲੇ ਹਨ",
    NO_EVENTS: "ਕੋਈ ਇਵੈਂਟ ਉਪਲਬਧ ਨਹੀਂ ਹੈ",
    NO_FAILED_EVENTS: "ਪਿਛਲੇ ਦਿਨ ਕੋਈ ਅਸਫਲ ਇਵੈਂਟ ਨਹੀਂ ਮਿਲਿਆ",
    NO_INVENTORY: "ਕੋਈ ਇਨਵੈਂਟਰੀ ਆਈਟਮ ਨਹੀਂ ਮਿਲੀ।",
    NO_LANES: "ਕੋਈ ਲੇਨ ਉਪਲਬਧ ਨਹੀਂ ਹੈ।",
    NO_MATCHES: "ਕੋਈ ਮੇਲ ਨਹੀਂ ਮਿਲਿਆ ਹੈ",
    NO_NON_FAILURE_EVENTS: "ਪਿਛਲੇ ਦਿਨ ਕੋਈ ਗੈਰ-ਅਸਫਲ ਇਵੈਂਟ ਨਹੀਂ ਮਿਲਿਆ ਹੈ",
    NO_VEHICLE_MEDIA: "ਕੋਈ ਵਾਹਨ ਮੀਡੀਆ ਉਪਲਬਧ ਨਹੀਂ ਹੈ",
    PRODUCT_NAME: "AVAC™",
    READ_AND_AGREE: "<BUTTON> ਛੋਟ ਫਾਰਮ</BUTTON> ਪੜ੍ਹੋ ਅਤੇ ਸਹਿਮਤ ਹੋਵੋ",
    SELECT_LANE: "ਲੇਨ ਚੁਣੋ",
    SUBMITTING: "ਸਬਮਿਟ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ...",
    SUGGESTION: {
      EMAIL_OR_PHONE_NUMBER: "ਈਮੇਲ ਜਾਂ ਫ਼ੋਨ ਨੰਬਰ ਫੀਲਡ ਭਰੋ",
    },
    TOAST: {
      APPROVE_EVENT_FAILED:
        "ਇਵੈਂਟ ਨੂੰ ਮਨਜ਼ੂਰੀ ਦੇਣ ਵਿੱਚ ਅਸਫਲ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
      EVENT_APPROVED:
        'ਇਵੈਂਟ ਸਫਲਤਾਪੂਰਵਕ ਮਨਜ਼ੂਰ ਹੋ ਗਿਆ ਹੈ! "Open Gate" ਬਟਨ \'ਤੇ ਕਲਿੱਕ ਕਰੋ।',
      EVENT_REJECTED: "ਇਵੈਂਟ ਅਸਵੀਕਾਰ ਕੀਤਾ ਗਿਆ।",
      GATE_OPENED: "ਗੇਟ ਸਫਲਤਾਪੂਰਵਕ ਖੋਲ੍ਹਿਆ ਗਿਆ!",
      OPEN_GATE_FAILED:
        "ਗੇਟ ਖੋਲ੍ਹਣ ਵਿੱਚ ਅਸਫਲ । ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ ਜਾਂ ਸਹਾਇਤਾ ਨਾਲ ਸੰਪਰਕ ਕਰੋ।",
      REJECT_EVENT_FAILED:
        "ਇਵੈਂਟ ਨੂੰ ਅਸਵੀਕਾਰ ਕਰਨ ਵਿੱਚ ਅਸਫਲ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
    },
    VALIDATING_ACCESS: "ਤੁਹਾਡੀ ਪਹੁੰਚ ਦੀ ਪੁਸ਼ਟੀ ਕੀਤੀ ਜਾ ਰਹੀ ਹੈ...",
    VALIDATION: {
      INVALID_EMAIL: "ਕਿਰਪਾ ਕਰਕੇ ਇੱਕ ਵੈਧ ਈਮੇਲ ਪਤਾ ਦਰਜ ਕਰੋ",
      INVALID_NAME: "ਇਸ ਵਿੱਚ ਸਿਰਫ਼ ਅੱਖਰ ਅਤੇ ਸਪੇਸ ਹੋਣੇ ਚਾਹੀਦੇ ਹਨ",
      INVALID_PHONE_NUMBER: "ਕਿਰਪਾ ਕਰਕੇ ਇੱਕ ਵੈਧ 10-ਅੰਕ ਵਾਲਾ ਫ਼ੋਨ ਨੰਬਰ ਦਰਜ ਕਰੋ",
    },
  },
  BRE: {
    FAILED_TO_OPEN_GATE: "ਗੇਟ ਖੋਲ੍ਹਣ ਵਿੱਚ ਅਸਫਲ",
    GATE_OPEN_FAILED: "ਗੇਟ ਖੋਲ੍ਹਣ ਵਿੱਚ ਅਸਫਲ",
    INVALID_APPOINTMENT: "ਅਵੈਧ ਅਪੌਇੰਟਮੈਂਟ",
    DRIVER_REGISTRATION_EXPIRED:
      "ਡਰਾਈਵਰ ਰਜਿਸਟ੍ਰੇਸ਼ਨ ਵੈਧ ਨਹੀਂ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ ਗੇਟ ਆਪਰੇਟਰ ਨਾਲ ਸੰਪਰਕ ਕਰੋ।",
    INVALID_QRCODE_FORMAT: "ਅਵੈਧ QR ਕੋਡ ਫਾਰਮੈਟ",
    KRAFT: {
      APPOINTMENT_USAGE_EXCEEDED: "ਅਪੌਇੰਟਮੈਂਟ ਵਰਤੋਂ ਸੀਮਾ ਪਾਰ ਹੋ ਚੁੱਕੀ ਹੈ",
      BOL_CALL_FAILED: "BOL ਕਾਲ ਅਸਫਲ ਰਹੀ",
      BOL_CALL_FAILED_NO_LANE_EVENT:
        "BOL ਕਾਲ ਅਸਫਲ ਰਹੀ ਜਾਂ InProgress CVLaneEvent ਨਹੀਂ ਮਿਲਿਆ",
      BOL_PO_MISSING: "BOL/PO ਨੰਬਰ ਅਪੌਇੰਟਮੈਂਟ ਵਿੱਚ ਮੌਜੂਦ ਨਹੀਂ ਹੈ",
      BOL_PO_MISSING_NO_LANE_EVENT:
        "BOL/PO ਨੰਬਰ ਅਪੌਇੰਟਮੈਂਟ ਵਿੱਚ ਮੌਜੂਦ ਨਹੀਂ ਹੈ ਅਤੇ InProgress CVLaneEvent ਨਹੀਂ ਮਿਲਿਆ",
      CVLANE_EVENT_NOT_FOUND: "CVLaneEvent ਮੌਜੂਦ ਨਹੀਂ ਹੈ",
      EVENT_OUTSIDE_OPERATION_HOURS: "ਇਵੈਂਟ ਕਾਰਜ ਘੰਟਿਆਂ ਤੋਂ ਬਾਹਰ ਹੈ",
      FAILED_OBTAIN_BOL_INFO: "BOL ਜਾਣਕਾਰੀ ਪ੍ਰਾਪਤ ਕਰਨ ਵਿੱਚ ਅਸਫਲ ਰਿਹਾ",
      FUEL_LEVEL_BELOW_THRESHOLD:
        "0.75 ਤੋਂ ਘੱਟ ਇੰਧਨ ਪੱਧਰ ਅਤੇ InProgress CVLaneEvent ਨਹੀਂ ਮਿਲਿਆ",
      FUEL_LEVEL_BELOW_THRESHOLD_NO_LANE_EVENT:
        "0.75 ਤੋਂ ਘੱਟ ਇੰਧਨ ਪੱਧਰ ਅਤੇ InProgress CVLaneEvent ਨਹੀਂ ਮਿਲਿਆ",
      INTERNAL_FAILURE: "ਅੰਦਰੂਨੀ ਅਸਫਲਤਾ",
      INVALID_APPOINTMENT_ENTRY_SUBTYPE: "ਅਵੈਧ ਅਪੌਇੰਟਮੈਂਟ ਐਂਟਰੀ ਦੀ ਉਪ-ਕਿਸਮ",
      INVALID_APPOINTMENT_ENTRY_TYPE: "ਅਵੈਧ ਅਪੌਇੰਟਮੈਂਟ ਐਂਟਰੀ ਦੀ ਕਿਸਮ",
      INVALID_APPOINTMENT_QR_CODE: "ਅਵੈਧ ਅਪੌਇੰਟਮੈਂਟ QR ਕੋਡ",
      INVALID_ENTRY_SUBTYPE: "ਅਵੈਧ ਐਂਟਰੀ ਦੀ ਉਪ-ਕਿਸਮ",
      INVALID_ENTRY_SUBTYPE_IN_APPOINTMENT: "ਅਪੌਇੰਟਮੈਂਟ ਵਿੱਚ ਅਵੈਧ ਐਂਟਰੀ ਦੀ ਉਪ-ਕਿਸਮ",
      INVALID_ENTRY_SUBTYPE_NO_LANE_EVENT:
        "ਅਪੌਇੰਟਮੈਂਟ ਵਿੱਚ ਅਵੈਧ ਐਂਟਰੀ ਦੀ ਉਪ-ਕਿਸਮ ਅਤੇ ਇਨਪ੍ਰੋਗਰੈਸ CVLaneEvent ਨਹੀਂ ਮਿਲਿਆ",
      INVALID_INBOUND_BOBTAIL_PLATE_NUMBER: "ਅਵੈਧ ਇਨਬਾਉਂਡ ਬੌਬਟੇਲ ਪਲੇਟ ਨੰਬਰ",
      INVALID_OUTBOUND_EMPTY_APPOINTMENT_USAGE: "ਅਵੈਧ ਆਊਟਬਾਉਂਡ ਖਾਲੀ ਅਪੌਇੰਟਮੈਂਟ ਦੀ ਵਰਤੋਂ",
      INVALID_QRCODE_SOURCE: "ਅਵੈਧ QR ਕੋਡ ਸਰੋਤ",
      MAX_APPOINTMENT_LIMIT_REACHED: "ਵੱਧ ਤੋਂ ਵੱਧ ਅਪੌਇੰਟਮੈਂਟ ਵਰਤੋਂ ਸੀਮਾ ਪੂਰੀ ਹੋ ਗਈ ਹੈ",
      NO_CV_LANE_EVENT_FOUND_OR_UNSUPPORTED_APPOINTMENT_MISMATCH_USAGE:
        "ਕੋਈ CV LaneEvent ਨਹੀਂ ਮਿਲੀ ਜਾਂ ਅਸਮਰਥਿਤ ਅਪੌਇੰਟਮੈਂਟ ਮੇਲ ਨਹੀਂ ਖਾਂਦਾ",
      NO_INPROGRESS_LANE_EVENT_FOUND: "ਕੋਈ InProgress LaneEvent ਨਹੀਂ ਮਿਲਿਆ",
      NO_INPROGRESS_LANE_EVENT_FOUND_OR_TRAILER_NUMBER_IS_PRESENT_IN_THE_RECORD:
        "ਕੋਈ InProgress LaneEvent ਨਹੀਂ ਮਿਲਿਆ ਜਾਂ ਰਿਕਾਰਡ ਵਿੱਚ ਟ੍ਰੇਲਰ ਨੰਬਰ ਮੌਜੂਦ ਹੈ",
      NO_USER_INFO_RECEIVED: "ਕੋਈ ਉਪਭੋਗਤਾ ਜਾਣਕਾਰੀ ਨਹੀਂ ਮਿਲੀ",
      NO_VEHICLE_DETECTED: "ਕੋਈ ਵਾਹਨ ਨਹੀਂ ਮਿਲਿਆ ਜਾਂ ਵਾਹਨ ਦੀ ਕਿਸਮ ਅਵੈਧ ਹੈ",
      NO_VEHICLE_DETECTED_BOBTAIL: "ਕੋਈ ਵਾਹਨ ਨਹੀਂ ਮਿਲਿਆ ਜਾਂ ਇਹ ਬੌਬਟੇਲ ਨਹੀਂ ਹੈ",
      PLEASE_PROCEED_TO_DOCK_OFFICE: "ਕਿਰਪਾ ਕਰਕੇ ਡੌਕ ਦਫਤਰ ਜਾਓ",
      SEAL_NUMBER_MISMATCH: "ਸੀਲ ਨੰਬਰ ਮੇਲ ਨਹੀਂ ਖਾਂਦਾ",
      SEAL_NUMBER_MISSING: "ਆਊਟਬਾਉਂਡ ਲੋਡ ਕੀਤੇ ਰਿਕਾਰਡ ਦਾ ਸੀਲ ਨੰਬਰ ਮੌਜੂਦ ਨਹੀਂ ਹੈ",
      TEMPERATURE_EXCEEDS_LIMIT: "ਤਾਪਮਾਨ ਸੀਮਾ ਤੋਂ ਵੱਧ ਹੈ",
      TEMPERATURE_INFO_MISSING:
        "ਤਾਪਮਾਨ ਜਾਣਕਾਰੀ ਮੌਜੂਦ ਨਹੀਂ ਹੈ ਅਤੇ ਮੌਜੂਦਾ ਮੌਸਮ ਦੇ ਕਾਰਨ, ਤਾਪਮਾਨ ਜਾਂਚ ਨੂੰ ਅਣਡਿੱਠਾ ਨਹੀਂ ਕੀਤਾ ਜਾ ਸਕਦਾ",
      TEMPERATURE_INFO_MISSING_NO_LANE_EVENT:
        "ਤਾਪਮਾਨ ਜਾਣਕਾਰੀ ਮੌਜੂਦ ਨਹੀਂ ਹੈ ਅਤੇ ਮੌਜੂਦਾ ਮੌਸਮ ਦੇ ਕਾਰਨ, ਤਾਪਮਾਨ ਜਾਂਚ ਨੂੰ ਅਣਡਿੱਠਾ ਨਹੀਂ ਕੀਤਾ ਜਾ ਸਕਦਾ। InProgress CVLaneEvent ਨਹੀਂ ਮਿਲਿਆ",
      TEMPERATURE_INFO_NOT_INCLUDED: "ਅਪੌਇੰਟਮੈਂਟ ਵਿੱਚ ਤਾਪਮਾਨ ਦੀ ਜਾਣਕਾਰੀ ਸ਼ਾਮਲ ਨਹੀਂ ਸੀ।",
      TEMPERATURE_INFO_NOT_INCLUDED_NO_LANE_EVENT:
        "ਅਪੌਇੰਟਮੈਂਟ ਵਿੱਚ ਤਾਪਮਾਨ ਦੀ ਜਾਣਕਾਰੀ ਸ਼ਾਮਲ ਨਹੀਂ ਸੀ ਅਤੇ InProgress CVLaneEvent ਨਹੀਂ ਮਿਲਿਆ।",
      TRAILER_NUMBER_DOES_NOT_MATCH: "ਟ੍ਰੇਲਰ ਨੰਬਰ ਮੇਲ ਨਹੀਂ ਖਾਂਦਾ।",
      TRAILER_NUMBER_DOES_NOT_MATCH_WITH_RECORD: "ਟ੍ਰੇਲਰ ਨੰਬਰ ਰਿਕਾਰਡ ਨਾਲ ਮੇਲ ਨਹੀਂ ਖਾਂਦਾ।",
      TRAILER_NUMBER_IS_NOT_AVAILABLE: "ਟ੍ਰੇਲਰ ਨੰਬਰ ਉਪਲੱਬਧ ਨਹੀਂ ਹੈ।",
      TRAILER_NUMBER_MISSING: "ਟ੍ਰੇਲਰ ਨੰਬਰ ਮੌਜੂਦ ਨਹੀਂ ਹੈ ਜਾਂ ਰਿਕਾਰਡ ਨਾਲ ਮੇਲ ਨਹੀਂ ਖਾਂਦਾ।",
      TRAILER_NUMBER_NOT_PRESENT: "ਟ੍ਰੇਲਰ ਨੰਬਰ ਅਪੌਇੰਟਮੈਂਟ ਵਿੱਚ ਮੌਜੂਦ ਨਹੀਂ ਹੈ",
      TRAILER_NUMBER_SHOULD_NOT_EXIST: "ਟ੍ਰੇਲਰ ਨੰਬਰ ਰਿਕਾਰਡ ਵਿੱਚ ਮੌਜੂਦ ਨਹੀਂ ਹੋਣਾ ਚਾਹੀਦਾ।",
      UNABLE_TO_VALIDATE_TEMPERATURE: "ਤਾਪਮਾਨ ਦੀ ਪੁਸ਼ਟੀ ਨਹੀਂ ਕੀਤੀ ਜਾ ਸਕੀ।",
      UNSUPPORTED_APPOINTMENT_TYPE: "ਅਸਮਰਥਿਤ ਅਪੌਇੰਟਮੈਂਟ ਕਿਸਮ ਮੇਲ ਨਹੀਂ ਖਾਂਦਾ।",
    },
    LACTALIS: {
      APPOINTMENT_DOES_NOT_EXIST: "ਅਪੌਇੰਟਮੈਂਟ ਮੌਜੂਦ ਨਹੀਂ ਹੈ।",
      OFF_HOURS_OUTBOUND_TRAILER:
        "ਆਫ਼-ਆਵਰਜ਼ ਦੌਰਾਨ ਟ੍ਰੇਲਰ ਨਾਲ ਬਾਹਰ ਜਾਣ ਵਾਲੇ ਨੂੰ ਇੰਟਰਕੌਮ ਦੀ ਵਰਤੋਂ ਕਰਨੀ ਚਾਹੀਦੀ ਹੈ।",
      OUTBOUND_TRAFFIC_WORKING_HOURS:
        "ਕੰਮ ਦੇ ਸਮਿਆਂ ਦੌਰਾਨ ਬਾਹਰ ਜਾਣ ਵਾਲੀ ਟ੍ਰੈਫ਼ਿਕ ਨੂੰ ਇੰਟਰਕੌਮ ਦੀ ਵਰਤੋਂ ਕਰਨੀ ਚਾਹੀਦੀ ਹੈ।",
      YMS_CHECKIN_FAILED: "YMS ਚੈੱਕ-ਇਨ ਅਸਫਲ ਰਿਹਾ। ਕਿਰਪਾ ਕਰਕੇ ਗੇਟ ਆਪਰੇਟਰ ਨਾਲ ਸੰਪਰਕ ਕਰੋ।",
    },
    LOBLAW: {
      ENTRY_APPROVED: "ਐਂਟਰੀ ਮਨਜ਼ੂਰ ਦਿੱਤੀ ਗਈ। ਕਿਰਪਾ ਕਰਕੇ ਪੈਡ {{MESSAGE}} 'ਤੇ ਜਾਓ",
      INVALID_INFORMATION: "ਅਵੈਧ ਜਾਣਕਾਰੀ",
      PROCEED_TO_DISPATCH: "{{MESSAGE}}  ਕਿਰਪਾ ਕਰਕੇ ਵੇਰਵਿਆਂ ਲਈ ਡਿਸਪੈਚ ਦਫਤਰ ਜਾਓ।",
      SEE_YOU_NEXT_TIME: "{{MESSAGE}} ਅਗਲੀ ਵਾਰ ਮਿਲਦੇ ਹਾਂ",
    },
    PORTCITY: {
      AFTER_HOURS_ENTRY:
        "ਕੰਮ ਦੇ ਘੰਟਿਆਂ ਤੋਂ ਬਾਅਦ ਐਂਟਰੀ ਲਈ, ਕਿਰਪਾ ਕਰਕੇ ਸੈਂਟਰ ਲੇਨ ਵਿੱਚ ਨੰਬਰ ਕੀਪੈਡ ਦੀ ਵਰਤੋਂ ਕਰੋ। ਇਹ ਕੋਡ ਤੁਹਾਡੇ ਡਿਸਪੈਚਰ ਦੁਆਰਾ ਦਿੱਤਾ ਗਿਆ ਹੈ।",
      BOOKING_NUMBER_PROVIDED_NOT_VALID: "ਦਿੱਤਾ ਗਿਆ ਬੁਕਿੰਗ ਨੰਬਰ ਵੈਧ ਨਹੀਂ ਹੈ",
      INVALID_EAIGLE_APPOINTMENT_RECORD: "ਈਗਲ ਅਪੌਇੰਟਮੈਂਟ ਰਿਕਾਰਡ ਅਵੈਧ ਹੈ",
      INVALID_PROFILE_OR_EXPIRED_CREDENTIAL:
        "ਪ੍ਰੋਫਾਈਲ ਅਵੈਧ ਹੈ ਜਾਂ ਪ੍ਰਮਾਣ ਪੱਤਰ ਦੀ ਮਿਆਦ ਖਤਮ ਹੋ ਗਈ ਹੈ",
      IT_IS_NOT_AN_OUTBOUND_BOBTAIL: "ਇਹ ਆਊਟਬਾਉਂਡ ਬੌਬਟੇਲ ਨਹੀਂ ਹੈ",
      IT_IS_NOT_A_BOBTAIL: "ਇਹ ਬੌਬਟੇਲ ਨਹੀਂ ਹੈ",
      LOADID_PROVIDED_IS_NOT_VALID: "ਦਿੱਤੀ ਗਈ ਲੋਡ ID ਵੈਧ ਨਹੀਂ ਹੈ",
      NO_BOOKING_NUMBER_PROVIDED: "ਕੋਈ ਬੁਕਿੰਗ ਨੰਬਰ ਨਹੀਂ ਦਿੱਤਾ ਗਿਆ",
      NO_INPROGRESS_CV_LANE_EVENT_FOUND: "ਕੋਈ InProgress CV LaneEvent ਨਹੀਂ ਮਿਲਿਆ",
      NO_LOADID_PROVIDED: "ਕੋਈ ਲੋਡ ID ਨਹੀਂ ਦਿੱਤੀ ਗਈ",
      PICK_UP_BOL: "{{MESSAGE}} BOL ਨੂੰ 25 ਨੰਬਰ ਗੇਟ ਤੋਂ ਚੁੱਕੋ",
      PLEASE_CONTACT_SECURITY_TO_OPEN_GATE:
        "ਗੇਟ ਖੋਲ੍ਹਣ ਲਈ ਕਿਰਪਾ ਕਰਕੇ ਸਕਿਉਰਟੀ ਨਾਲ ਸੰਪਰਕ ਕਰੋ",
      UNSUPPORTED_APPOINTMENT_TYPE: "ਅਸਮਰਥਿਤ ਅਪੌਇੰਟਮੈਂਟ ਕਿਸਮ",
      UNSUPPORTED_OPERATION_TYPE: "ਅਸਮਰਥਿਤ ਕਾਰਜ ਕਿਸਮ",
    },
    TRIMAC: {
      NOT_A_VALID_REQUEST: "ਇੱਕ ਵੈਧ ਬੇਨਤੀ ਨਹੀਂ ਹੈ",
    },
  },
  CARRIER: {
    SCAC_AND_NAME: "{{SCAC}} ({{NAME}})",
    NAME_AND_SCAC: "{{NAME}} ({{SCAC}})",
  },
  CATEGORY: {
    ACTUAL_TEMPERATURE: "ਅਸਲ ਤਾਪਮਾਨ",
    ACTUAL_TEMPERATURE_F: "ਅਸਲ ਤਾਪਮਾਨ °F",
    COMPANY: "ਕੰਪਨੀ ਦੀ ਜਾਣਕਾਰੀ",
    EQUIPMENT_DETAILS: "ਉਪਕਰਨ ਦੇ ਵੇਰਵੇ",
    LOAD_DETAILS: "ਲੋਡ ਦੇ ਵੇਰਵੇ",
    PERSONAL: "ਨਿੱਜੀ ਜਾਣਕਾਰੀ",
    PURPOSE_DETAILS: "ਉਦੇਸ਼ ਦੇ ਵੇਰਵੇ",
    SAFETY: "ਸੁਰੱਖਿਆ",
    SET_TEMPERATURE: "ਤਾਪਮਾਨ ਨਿਰਧਾਰਿਤ ਕਰੋ",
    SET_TEMPERATURE_F: "ਤਾਪਮਾਨ °F ਨਿਰਧਾਰਿਤ ਕਰੋ",
    SHIPPING_DETAILS: "ਸ਼ਿਪਿੰਗ ਦੇ ਵੇਰਵੇ",
    SHIPPING_DETAILS_WITHOUT_VALIDATION: "ਬਿਨਾਂ ਪੁਸ਼ਟੀਕਰਨ ਦੇ ਸ਼ਿਪਿੰਗ ਵੇਰਵੇ",
    SHIPPING_DETAILS_WITH_VALIDATION: "ਪੁਸ਼ਟੀਕਰਨ ਦੇ ਨਾਲ ਸ਼ਿਪਿੰਗ ਵੇਰਵੇ",
    VEHICLE_EQUIPMENT_DETAILS: "ਵਾਹਨ/ਉਪਕਰਨ ਦੇ ਵੇਰਵੇ",
    VISIT_PURPOSE: "ਵਿਜ਼ਿਟ ਦਾ ਉਦੇਸ਼",
  },
  COMMAND: {
    ADD_NEW_DRIVER: "ਨਵਾਂ ਡਰਾਈਵਰ ਸ਼ਾਮਲ ਕਰੋ",
    APPROVE: "ਮਨਜ਼ੂਰ ਕਰੋ",
    BACK: "ਵਾਪਸ ਜਾਓ",
    BACK_TO_EVENTS: "ਇਵੈਂਟਸ 'ਤੇ ਵਾਪਸ",
    CHECK_IN: "ਚੈੱਕ-ਇਨ",
    CHECK_OUT: "ਚੈੱਕ-ਆਊਟ",
    CLEAR: "ਕਲੀਅਰ ਕਰੋ",
    CLICK_TO_EDIT: "ਸੰਪਾਦਨ ਕਰਨ ਲਈ ਕਲਿੱਕ ਕਰੋ",
    CLOSE: "ਬੰਦ ਕਰੋ",
    CLOSE_IMAGE_MODAL: "ਚਿੱਤਰ ਮੋਡਲ ਬੰਦ ਕਰੋ",
    DELETE: "ਮਿਟਾਓ",
    EDIT: "ਸੰਪਾਦਨ ਕਰੋ",
    LOGOUT: "ਲੌਗਆਉਟ ਕਰੋ",
    NEXT: "ਅੱਗੇ",
    OPEN_GATE: "ਗੇਟ ਖੋਲ੍ਹੋ",
    REJECT: "ਅਸਵੀਕਾਰ ਕਰੋ",
    RETURN: "ਵਾਪਸ ਜਾਓ",
    SELECT_END: "ਸਮਾਪਤ ਚੁਣੋ",
    SELECT_START: "ਸ਼ੁਰੂ ਕਰੋ ਚੁਣੋ",
    SSO_LOGIN: "Azure AD ਨਾਲ ਸਾਈਨ ਇਨ ਕਰੋ",
    START_NEW_REGISTRATION: "ਨਵੀਂ ਰਜਿਸਟ੍ਰੇਸ਼ਨ ਸ਼ੁਰੂ ਕਰੋ",
    SUBMIT: "ਸਬਮਿਟ ਕਰੋ",
    TODAY: "ਅੱਜ",
    UPDATE: "ਅੱਪਡੇਟ",
  },
  DAY: {
    "0": "ਐਤਵਾਰ",
    "1": "ਸੋਮਵਾਰ",
    "2": "ਮੰਗਲਵਾਰ",
    "3": "ਬੁੱਧਵਾਰ",
    "4": "ਵੀਰਵਾਰ",
    "5": "ਸ਼ੁੱਕਰਵਾਰ",
    "6": "ਸ਼ਨੀਵਾਰ",
  },
  ERROR: {
    VIDEO_NOT_SUPPORTED: "ਤੁਹਾਡਾ ਬ੍ਰਾਊਜ਼ਰ ਵੀਡੀਓ ਟੈਗ ਨੂੰ ਸਪੋਰਟ ਨਹੀਂ ਕਰਦਾ ਹੈ।",
  },
  ERROR_MODAL: {
    INVALID_X: "ਅਵੈਧ {{TITLE}}",
  },
  EVENT_STATUS: {
    APPROVED: "ਮਨਜ਼ੂਰੀ ਦਿੱਤੀ ਗਈ",
    FAILURE: "ਅਸਫਲਤਾ",
    INPROGRESS: "ਪ੍ਰਗਤੀ ਅਧੀਨ",
    REJECTED: "ਅਸਵੀਕਾਰ ਕੀਤਾ ਗਿਆ",
    SUCCESS: "ਸਫਲਤਾ",
  },
  FAILURE_PAGE: {
    BODY: "ਕਿਓਸਕ 'ਤੇ ਇੰਟਰਕਾਮ ਬਟਨ ਦਬਾਓ",
    FAILURE: "ਅਸਫਲਤਾ",
    HEADER: "ਜਾਣਕਾਰੀ ਦੀ ਪੁਸ਼ਟੀ ਨਹੀਂ ਹੋਈ!",
    INTERCOM: "ਇੰਟਰਕਾਮ",
  },
  FILTER: {
    CARD: {
      EVENT_TYPE: "ਇਵੈਂਟ ਦੀ ਕਿਸਮ",
      STATUS: "ਸਥਿਤੀ",
      TIME: "ਸਮਾਂ",
      TRAILER_LOGO: "ਟ੍ਰੇਲਰ ਲੋਗੋ",
    },
    EVENT_TYPE: {
      JB_HUNT: "JB ਹੰਟ",
    },
    LOGO: {
      AB: "AB",
      CD: "CD",
      DH: "DH",
      EF: "EF",
    },
    STATUS: {
      CLEAN: "ਸਾਫ਼",
      DIRTY: "ਗੰਦਾ",
      EMPTY: "ਖਾਲੀ",
      INBOUND: "ਇੰਨਬਾਊਂਡ",
      LOADED: "ਲੋਡ ਕੀਤਾ ਗਿਆ",
      OUTBOUND: "ਆਊਟਬਾਊਂਡ",
    },
    TIME: {
      LAST_24_HOURS: "L 24",
      LAST_MONTH: "L ਮਹੀਨਾ",
      LAST_WEEK: "L ਹਫ਼ਤਾ",
      LAST_YEAR: "L ਸਾਲ",
      TODAY: "ਅੱਜ",
    },
  },
  FORM_INPUT: {
    COMMAND: {
      ENTER_SCAC: "SCAC ਨੂੰ ਹੱਥੀਂ ਦਰਜ ਕਰਨ ਲਈ ਕਲਿੱਕ ਕਰੋ",
      SELECT_SCAC: "ਉਪਲਬਧ SCAC ਕੋਡਾਂ ਵਿੱਚੋਂ ਚੁਣਨ ਲਈ ਕਲਿੱਕ ਕਰੋ",
      SHOW_LESS: "ਘੱਟ ਦਿਖਾਓ",
      SHOW_MORE: "ਹੋਰ ਦਿਖਾਓ",
    },
    FIELD_IS_REQUIRED: "ਇਹ ਫੀਲਡ ਲੋੜੀਂਦਾ ਹੈ",
    NO_MATCHES: "ਕੋਈ ਮੇਲ ਨਹੀਂ ਮਿਲਿਆ",
    REQUIRED_LABEL: "{{TEXT}}*",
    SELECT: "ਖੋਜੋ ਜਾਂ ਚੁਣੋ...",
    SELECT_CARRIER: "ਕਰੀਅਰ ਦੀ ਖੋਜ ਕਰੋ ਜਾਂ ਚੁਣੋ...",
    SELECT_DATE: "ਇੱਕ ਮਿਤੀ ਚੁਣੋ",
    SELECT_OPTIONS: "ਇੱਕ ਵਿਕਲਪ ਚੁਣੋ...",
    TRUNCATED: "{{TEXT}}...",
  },
  FORM_PAGE: {
    COMMAND: {
      NEXT: "ਅੱਗੇ",
      SUBMIT: "ਸਬਮਿਟ ਕਰੋ",
    },
    ERROR: {
      UNABLE_TO_SUBMIT:
        "ਫਾਰਮ ਸਬਮਿਟ ਨਹੀਂ ਕੀਤਾ ਜਾ ਸਕਿਆ। ਕਿਰਪਾ ਕਰਕੇ ਬਾਅਦ ਵਿੱਚ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
    },
    VALIDATING: "ਪੁਸ਼ਟੀਕਰਨ ਹੋ ਰਿਹਾ ਹੈ....",
  },
  HINT: {
    EDIT_SEAL_NUMBER: "* ਜੇਕਰ ਜ਼ਰੂਰੀ ਹੋਵੇ, ਤਾਂ ਭਰੇ ਹੋਏ ਸੀਲ ਨੰਬਰ ਨੂੰ ਸੰਪਾਦਿਤ ਕਰੋ।",
    LOAD_ID_8_DIGITS: "ਤੁਹਾਡੀ ਲੋਡ ID ਇੱਕ 8-ਅੰਕਾਂ ਦਾ ਨੰਬਰ ਹੈ ਜੋ 4 ਨਾਲ ਸ਼ੁਰੂ ਹੁੰਦਾ ਹੈ।",
    SCAC_NOT_LISTED_CPU9:
      "ਜੇਕਰ ਤੁਹਾਡਾ SCAC ਸੂਚੀਬੱਧ ਨਹੀਂ ਹੈ, ਤਾਂ ਕਿਰਪਾ ਕਰਕੇ CPU9 ਦਰਜ ਕਰੋ।",
  },
  IDCAPTURE: {
    CAMERA_ERROR: {
      BODY: "ਅਸੀਂ ਤੁਹਾਡੇ ਕੈਮਰੇ ਤੱਕ ਪਹੁੰਚ ਨਹੀਂ ਕਰ ਸਕੇ। ਕਿਰਪਾ ਕਰਕੇ ਅਨੁਮਤੀਆਂ ਦੀ ਜਾਂਚ ਕਰੋ ਅਤੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
      HEADER: "ਕੈਮਰੇ ਤੱਕ ਪਹੁੰਚ ਦੀ ਐਰਰ",
    },
    COMMAND: {
      CAPTURE: "ਕੈਪਚਰ ID",
      CAPTURING: "ਕੈਪਚਰਿੰਗ...",
      CHANGE_TYPE: "ID ਦੀ ਕਿਸਮ ਬਦਲੋ",
      DONE: "ਹੋ ਗਿਆ",
      RETAKE_PHOTOS: "ਫੋਟੋ ਦੁਬਾਰਾ ਲਓ",
      SUBMIT: "ਸਬਮਿਟ ਕਰੋ",
      SWITCH_CAMERA: "ਕੈਮਰਾ ਬਦਲੋ",
      TRY_AGAIN: "ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
      TRY_BACK: "ਪਿਛਲਾ ਕੈਮਰਾ ਅਜ਼ਮਾਓ",
      TRY_FRONT: "ਫਰੰਟ ਕੈਮਰਾ ਅਜ਼ਮਾਓ",
    },
    EMPLOYEE_ID_BACK: "ਕਰਮਚਾਰੀ ID (ਪਿਛਲਾ)",
    EMPLOYEE_ID_BACK_ALT: "ਕਰਮਚਾਰੀ ID (ਪਿਛਲਾ)",
    EMPLOYEE_ID_FRONT: "ਕਰਮਚਾਰੀ ID (ਸਾਹਮਣੇ)",
    EMPLOYEE_ID_FRONT_ALT: "ਕਰਮਚਾਰੀ ID ਸਾਹਮਣੇ",
    ERROR: {
      EXPIRED: "ID ਦੀ ਮਿਆਦ ਪੂਰੀ ਹੋ ਚੁੱਕੀ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ ਇੱਕ ਵੈਧ ID ਪ੍ਰਦਾਨ ਕਰੋ।",
      GENERIC: "ਕੁਝ ਗਲਤ ਹੋਇਆ ਹੈ",
      NO_CAMERA:
        "ਕੋਈ ਕੈਮਰਾ ਡਿਵਾਈਸ ਐਕਸੈਸ ਨਹੀਂ ਕੀਤਾ ਜਾ ਸਕਦਾ। ਕਿਰਪਾ ਕਰਕੇ ਆਪਣੇ ਕੈਮਰੇ ਨੂੰ ਕਨੈਕਟ ਕਰੋ ਜਾਂ ਇੱਕ ਵੱਖਰਾ ਬ੍ਰਾਊਜ਼ਰ ਅਜ਼ਮਾਓ।",
      NO_SWITCH:
        "ਸਿਰਫ਼ ਇੱਕ ਵੀਡੀਓ ਡਿਵਾਈਸ ਐਕਸੈਸ ਕੀਤੇ ਜਾਣ ਕਾਰਨ, ਕੈਮਰੇ ਨੂੰ ਦੂਜੇ ਬ੍ਰਾਊਜ਼ਰ ਵਿੱਚ ਬਦਲਣਾ ਸੰਭਵ ਨਹੀਂ ਹੈ।",
      PERMISSION_DENIED:
        "ਅਨੁਮਤੀ ਤੋਂ ਇਨਕਾਰ ਕੀਤਾ ਗਿਆ। ਕਿਰਪਾ ਕਰਕੇ ਰਿਫ੍ਰੈਸ਼ ਕਰੋ ਅਤੇ ਕੈਮਰੇ ਦੀ ਇਜਾਜ਼ਤ ਦਿਓ।",
      UNREADABLE: "ID ਜਾਣਕਾਰੀ ਪੜ੍ਹੀ ਨਹੀਂ ਜਾ ਸਕੀ।",
      UNSUPPORTED: "ਕੈਨਵਸ ਸਮਰਥਿਤ ਨਹੀਂ ਹੈ।",
      UPLOAD_FAILED: "ਕਰਮਚਾਰੀ ID ਦੀਆਂ ਫੋਟੋਆਂ ਅਪਲੋਡ ਕਰਨ ਵਿੱਚ ਅਸਫਲ ਰਿਹਾ",
      UPLOAD_FAILED_TRY_AGAIN:
        "ਕਰਮਚਾਰੀ ID ਦੀਆਂ ਫੋਟੋਆਂ ਅਪਲੋਡ ਕਰਨ ਵਿੱਚ ਅਸਫਲ ਰਿਹਾ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
      VERIFY_FAILED_TRY_AGAIN:
        "ID ਦੀ ਪੁਸ਼ਟੀ ਕਰਨ ਵਿੱਚ ਅਸਫਲ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
    },
    ID_INFORMATION: "ID ਦੀ ਜਾਣਕਾਰੀ",
    ID_NOT_VERIFIED_MESSAGE:
      "ਅਸੀਂ ਤੁਹਾਡੀ ID ਦੀ ਪੂਰੀ ਤਰ੍ਹਾਂ ਪੁਸ਼ਟੀ ਨਹੀਂ ਕਰ ਸਕੇ। ਕਿਰਪਾ ਕਰਕੇ ਹੇਠਾਂ ਵੇਰਵੇ ਵੇਖੋ।",
    ID_NOT_VERIFIED_STATUS: "ID ਦੀ ਪੁਸ਼ਟੀਕਰਨ ਦੀਆਂ ਸਮੱਸਿਆਵਾਂ",
    ID_VERIFIED_MESSAGE: "ਤੁਹਾਡੀ ਪਛਾਣ ਦੀ ਸਫਲਤਾਪੂਰਵਕ ਪੁਸ਼ਟੀ ਕੀਤੀ ਗਈ ਹੈ।",
    ID_VERIFIED_STATUS: "ID ਦੀ ਪੁਸ਼ਟੀਕਰਨ ਸਫਲ ਰਹੀ",
    INSTRUCTIONS: {
      DRIVERS_LICENSE:
        "ਆਪਣੇ ਡਰਾਈਵਿੰਗ ਲਾਇਸੈਂਸ ਨੂੰ ਫਰੇਮ ਵਿੱਚ ਰੱਖੋ ਅਤੇ ਚੰਗੀ ਰੋਸ਼ਨੀ ਯਕੀਨੀ ਬਣਾਓ।",
      EMPLOYEE_ID_BACK: "ਹੁਣ ਆਪਣੀ ਕਰਮਚਾਰੀ ID ਦਾ ਪਿੱਛਲਾ ਪਾਸਾ ਫਰੇਮ ਵਿੱਚ ਰੱਖੋ।",
      EMPLOYEE_ID_FRONT: "ਆਪਣੇ ਕਰਮਚਾਰੀ ID ਦੇ ਸਾਹਮਣੇ ਵਾਲੇ ਪਾਸੇ ਨੂੰ ਫਰੇਮ ਵਿੱਚ ਰੱਖੋ।",
    },
    PROCESSING: "ਪ੍ਰੋਸੈਸਿੰਗ...",
    SELECT_TYPE: "ID ਦੀ ਕਿਸਮ ਚੁਣੋ",
    TYPE: {
      DRIVERS_LICENSE: "ਡਰਾਈਵਰ ਦਾ ਲਾਇਸੈਂਸ",
      EMPLOYEE_ID: "ਕਰਮਚਾਰੀ  ਦੀ ID",
    },
  },
  IMAGE_PREVIEW: {
    CAPTURED_ID: "ਕੈਪਚਰ ਕੀਤੀ ਗਈ ID",
    COMMAND: {
      RETAKE: "ਰੀ-ਟੇਕ",
      SUBMIT: "ਸਬਮਿਟ ਕਰੋ",
    },
    PLEASE_WAIT: "ਕਿਰਪਾ ਕਰਕੇ ਉਡੀਕ ਕਰੋ ਜਦੋਂ ਤੱਕ ਅਸੀਂ ਤੁਹਾਡੀ ਜਾਣਕਾਰੀ ਦੀ ਪੁਸ਼ਟੀ ਕਰ ਰਹੇ ਹਾਂ।",
    PROCESSING_ID: "ਤੁਹਾਡੀ ID ਦੀ ਪ੍ਰੋਸੈਸਿੰਗ ਹੋ ਰਹੀ ਹੈ...",
    SUBMITTING: "ਸਬਮਿਟ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ...",
    TIP: "ਯਕੀਨੀ ਬਣਾਓ ਕਿ ਫੋਟੋ ਸਾਫ਼ ਅਤੇ ਪੜ੍ਹਨਯੋਗ ਹੈ।",
  },
  KIOSK: {
    COMMAND: {
      ENTER: "ਦਰਜ ਕਰੋ",
      REGISTER_NOW: "ਹੁਣੇ ਰਜਿਸਟਰ ਕਰੋ",
    },
    ERROR: {
      CONNECTION_CLOSED: "ਕੁਨੈਕਸ਼ਨ ਬੰਦ ਕਰ ਦਿੱਤਾ ਗਿਆ ਹੈ",
      CONNECTION_ERROR: "ਕੁਨੈਕਸ਼ਨ ਐਰਰ",
      ENTRY_TYPE_INVALID: 'ਐਂਟਰੀ ਦੀ ਕਿਸਮ "{{TYPE}}" ਅਵੈਧ ਹੈ',
      ENTRY_TYPE_MISSING: "ਐਂਟਰੀ ਦੀ ਕਿਸਮ ਮੌਜੂਦ ਨਹੀਂ ਹੈ",
      FAILED_TO_CONNECT: "ਕੁਨੈਕਸ਼ਨ ਸਥਾਪਤ ਕਰਨ ਵਿੱਚ ਅਸਫਲ",
      INFORMATION_NOT_VERIFIED_USE_INTERCOM:
        "ਜਾਣਕਾਰੀ ਦੀ ਪੁਸ਼ਟੀ ਨਹੀਂ ਕੀਤੀ ਗਈ! ਇੰਟਰਕਾਮ ਦੀ ਵਰਤੋਂ ਕਰੋ",
      INTERACTION_TYPE_INVALID: 'ਇੰਟਰਐਕਸ਼ਨ ਦੀ ਕਿਸਮ "{{TYPE}}" ਅਵੈਧ ਹੈ',
      INTERACTION_TYPE_MISSING: "ਇੰਟਰਐਕਸ਼ਨ ਦੀ ਕਿਸਮ ਮੌਜੂਦ ਨਹੀਂ ਹੈ",
      INTERMITTENT_CONNECTION: "ਅਸਥਿਰ ਕਨੈਕਸ਼ਨ ਐਰਰ",
      INTERMITTENT_CONNECTION_N:
        "ਅਸਥਿਰ ਕਨੈਕਸ਼ਨ ਐਰਰ {{N}}; ਜੇ ਸਮੱਸਿਆ ਜਾਰੀ ਰਹੇ ਤਾਂ ਕਿਰਪਾ ਕਰਕੇ EAIGLE ਸਪੋਰਟ ਨਾਲ ਸੰਪਰਕ ਕਰੋ @ 1 888 771 1584",
      MISSING_REQUIRED_INFO: "ਲੋੜੀਂਦੀ ਜਾਣਕਾਰੀ ਮੌਜੂਦ ਨਹੀਂ ਹੈ।",
      PROCESSING_ERROR:
        "ਤੁਹਾਡੀ ਬੇਨਤੀ ਦੀ ਪ੍ਰੋਸੈਸਿੰਗ ਕਰਨ ਵਿੱਚ ਐਰਰ। ਕਿਰਪਾ ਕਰਕੇ ਇੰਟਰਕਾਮ ਦੀ ਵਰਤੋਂ ਕਰੋ।",
      VALIDATION_FAILED: "ਪੁਸ਼ਟੀਕਰਨ ਦੀ ਪ੍ਰੀਕਿਰਿਆ ਅਸਫਲ ਰਹੀ।",
      VALIDATION_TIMEOUT: "ਪੁਸ਼ਟੀਕਰਨ ਦਾ ਸਮਾਂ ਸਮਾਪਤ।",
    },
    FOOTER: {
      NOT_REGISTERED: "ਰਜਿਸਟਰਡ ਨਹੀਂ ਹੈ?",
    },
    GATE_OPEN: "ਗੇਟ ਖੁੱਲ੍ਹਿਆ।",
    INFORMATION_VERIFIED: "ਜਾਣਕਾਰੀ ਦੀ ਪੁਸ਼ਟੀ ਹੋ ਗਈ ਹੈ!",
    INVALID_URL_PARAMETERS: "ਅਵੈਧ URL ਪੈਰਾਮੀਟਰ।",
    KEY: {
      BACKSPACE: "ਬੈਕਸਪੇਸ।",
      CLEAR: "ਕਲੀਅਰ ਕਰੋ।",
      CLOSE: "ਬੰਦ ਕਰੋ।",
    },
    KEY_PAD_INSTRUCTIONS: "OTP ਦਰਜ ਕਰੋ।",
    PLEASE_ROTATE_LANDSCAPE: "ਕਿਰਪਾ ਕਰਕੇ ਆਪਣੇ ਡਿਵਾਈਸ ਨੂੰ ਲੈਂਡਸਕੇਪ ਮੋਡ ਵਿੱਚ ਘੁੰਮਾਓ।",
    PLEASE_WAIT_X: "ਕਿਰਪਾ ਕਰਕੇ ਉਡੀਕ ਕਰੋ। {{TEXT}}",
    PRE_REGISTERED: "ਪਹਿਲਾਂ ਤੋਂ ਰਜਿਸਟਰਡ?",
    PROCEED_TO_EXIT: "ਕਿਰਪਾ ਕਰਕੇ ਬਾਹਰ ਜਾਓ।",
    PROCEED_TO_ZONE: "ਨਿਰਧਾਰਤ ਖੇਤਰ ਵਿੱਚ ਜਾਓ।",
    REDIRECTING: "ਰੀਡਾਇਰੈਕਟ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ...",
    SCAN_QR_CODE: "<br/>ਸਕੈਨਿੰਗ ਲਈ ਕਿਓਸਕ 'ਤੇ ਆਪਣਾ ਪਹਿਲਾਂ ਤੋਂ ਰਜਿਸਟਰਡ QR ਕੋਡ ਰੱਖੋ।",
    SECONDS_REMAINING: "{{N}} ਸਕਿੰਟ ਬਾਕੀ ਹਨ",
    TROUBLE_SCANNING_QR_CODE:
      "QR ਕੋਡ ਸਕੈਨ ਕਰਨ ਵਿੱਚ ਸਮੱਸਿਆ - ਅਪਾਇੰਟਮੈਂਟ ਕੋਡ ਹੱਥੀਂ ਦਰਜ ਕਰਨ ਲਈ ਇੱਥੇ ਕਲਿੱਕ ਕਰੋ",
    VALIDATION: {
      PERSON_NAME: "ਸਿਰਫ਼ ਅੱਖਰ ਅਤੇ ਸਪੇਸ",
      PHONE_NUMBER: "ਉਦਾਹਰਨ ਲਈ, 1234567890",
    },
    VERIFYING_INFORMATION: "ਜਾਣਕਾਰੀ ਦੀ ਪੁਸ਼ਟੀ ਕੀਤੀ ਜਾ ਰਹੀ ਹੈ...",
    VIDEO_NOT_AVAILABLE: "ਲਾਈਵ ਵੀਡੀਓ ਉਪਲਬਧ ਨਹੀਂ ਹੈ",
    WAIT_VERIFY_INFO:
      "ਜਦੋਂ ਤੱਕ ਅਸੀਂ ਤੁਹਾਡੀ ਜਾਣਕਾਰੀ ਦੀ ਪੁਸ਼ਟੀ ਕਰ ਰਹੇ ਹਾਂ ਕਿਰਪਾ ਕਰਕੇ ਉਡੀਕ ਕਰੋ",
    WAIT_VERIFY_QR: "ਕਿਰਪਾ ਕਰਕੇ QR ਕੋਡ ਦੀ ਪੁਸ਼ਟੀ ਹੋਣ ਤੱਕ ਉਡੀਕ ਕਰੋ",
  },
  LABEL: {
    APPROVED: "ਮਨਜ਼ੂਰ ਕੀਤਾ ਗਿਆ",
    AREA: "ਖੇਤਰ",
    CARRIER: "ਕੈਰੀਅਰ",
    CHECK_ICON: "ਚੈੱਕ ਆਈਕਨ",
    CHECK_IN_TIME: "ਚੈੱਕ-ਇਨ ਦਾ ਸਮਾਂ",
    CHECK_OUT_TIME: "ਚੈੱਕ-ਆਊਟ ਦਾ ਸਮਾਂ",
    DETENTION_TIME: "ਡਿਟੈਂਸ਼ਨ ਦਾ ਸਮਾਂ",
    INDICATORS: "ਸੂਚਕ",
    DETENTION_TIME_HOURS: "ਡਿਟੈਂਸ਼ਨ ਦਾ ਸਮਾਂ (ਘੰਟੇ)",
    DRIVERS: "ਡਰਾਈਵਰ",
    DURATION: "ਮਿਆਦ",
    ERROR_ICON: "ਐਰਰ ਆਈਕਨ",
    FIRST_NAME_LAST_NAME: "{{ਪਹਿਲਾ}} {{ਆਖਰੀ}}",
    FROM_DATE_TIME_TZ: "ਵੱਲੋਂ: {{DATE_TIME_TZ}}",
    GATE_LOG: "ਗੇਟ ਲੌਗ",
    GATE_OPEN: "ਗੇਟ ਖੁੱਲ੍ਹਿਆ",
    LOCATION: "ਸਥਾਨ",
    NOT_APPLICABLE: "ਲਾਗੂ ਨਹੀਂ",
    OPENING: "ਖੁੱਲ ਰਿਹਾ ਹੈ...",
    REGISTRATION: "ਰਜਿਸਟ੍ਰੇਸ਼ਨ",
    ROW: "ਲਾਈਨ",
    SECTION_N: "{{SECTION}} {{N}}",
    SPOT: "ਸਥਾਨ",
    STEP_N: "ਕਦਮ {{N}}",
    TANKER: "ਟੈਂਕਰ",
    TIME: "ਸਮਾਂ",
    TIME_STAMP: "ਟਾਈਮ ਸਟੈਂਪ",
    TOTAL_RECORDS_N: "ਕੁੱਲ ਰਿਕਾਰਡ: {{N}}",
    TO_DATE_TIME_TZ: "ਜਦੋਂ ਤੱਕ: {{DATE_TIME_TZ}}",
    UNIT_1: "ਯੂਨਿਟ 1",
    UNIT_HISTORY: "ਯੂਨਿਟ ਇਤਿਹਾਸ",
    UNIT_ID: "ਯੂਨਿਟ ਦੀ ID",
    UNIT_TYPE: "ਯੂਨਿਟ ਦੀ ਕਿਸਮ",
    YARD_CHECK: "ਯਾਰਡ ਚੈੱਕ",
    YARD_INVENTORY: "ਯਾਰਡ ਇਨਵੈਂਟਰੀ",
    ZOOMABLE_TYPE: "ਜ਼ੂਮ ਕਰਨ ਯੋਗ {{TYPE}}",
  },
  MONTH: {
    "1": "ਜਨਵਰੀ",
    "2": "ਫਰਵਰੀ",
    "3": "ਮਾਰਚ",
    "4": "ਅਪ੍ਰੈਲ",
    "5": "ਮਈ",
    "6": "ਜੂਨ",
    "7": "ਜੁਲਾਈ",
    "8": "ਅਗਸਤ",
    "9": "ਸਤੰਬਰ",
    "10": "ਅਕਤੂਬਰ",
    "11": "ਨਵੰਬਰ",
    "12": "ਦਸੰਬਰ",
  },
  NAVBAR: {
    COMMAND: {
      PREVIOUS: "ਪਿਛਲਾ",
    },
    DRIVER_REGISTRATION: "ਡਰਾਈਵਰ ਰਜਿਸਟ੍ਰੇਸ਼ਨ",
    LOGO: "ਲੋਗੋ",
  },
  PASSCODE_PAGE: {
    COMMAND: {
      VERIFY: "ਪੁਸ਼ਟੀ ਕਰੋ",
    },
    ENTER_PASSCODE: "ਪਾਸਕੋਡ ਦਰਜ ਕਰੋ",
    ERROR: {
      INVALID_PASSCODE: "ਅਵੈਧ ਪਾਸਕੋਡ",
    },
  },
  PLACEHOLDER: {
    ACTUAL_TEMPERATURE_F: "ਅਸਲ ਤਾਪਮਾਨ (°F)",
    BOL_OR_PO_NUMBERS: "BOL(s) / PO(s)",
    BOOKING_NUMBER: "ਬੁਕਿੰਗ ਨੰਬਰ",
    CARRIER: "ਕੈਰੀਅਰ",
    CARRIER_NAME_PARENT_SCAC: "ਕੈਰੀਅਰ ਦਾ ਨਾਮ (ਮੁੱਖ SCAC ਕੋਡ)",
    CARRIER_SCAC: "ਕੈਰੀਅਰ ਦਾ SCAC ਦਰਜ ਕਰੋ",
    COMPANY_NAME: "ਕੰਪਨੀ ਦਾ ਨਾਮ",
    CURRENT_TEMPERATURE_F: "ਮੌਜੂਦਾ ਤਾਪਮਾਨ (°F)",
    CVIP_DATE: "CVIP ਮਿਤੀ",
    DRIVER_FIRST_NAME: "ਡਰਾਈਵਰ ਦਾ ਪਹਿਲਾ ਨਾਮ",
    DRIVER_LAST_NAME: "ਡਰਾਈਵਰ ਦਾ ਆਖਰੀ ਨਾਮ",
    DRIVER_NAME: "ਡਰਾਈਵਰ ਦਾ ਨਾਮ",
    DRIVER_TYPE: "ਡਰਾਈਵਰ ਦੀ ਕਿਸਮ",
    DUNNAGE: "ਡੰਨੇਜ",
    EMAIL: "ਈਮੇਲ",
    EMAIL_ADDRESS: "ਈਮੇਲ ਪਤਾ",
    ENTRY_TYPE_REASON: "ਐਂਟਰੀ ਦੀ ਕਿਸਮ (ਵਿਜ਼ਿਟ ਦਾ ਕਾਰਨ)",
    EQUIPMENT_LENGTH: "ਉਪਕਰਨ ਦੀ ਲੰਬਾਈ",
    EQUIPMENT_LOADED_STATUS: "ਉਪਕਰਨ ਲੋਡ ਕਰਨ ਦੀ ਸਥਿਤੀ",
    EQUIPMENT_TYPE: "ਉਪਕਰਨ ਦੀ ਕਿਸਮ",
    FIRST_NAME: "ਪਹਿਲਾ ਨਾਮ",
    FUEL_LEVEL: "ਇੰਧਨ ਦਾ ਪੱਧਰ",
    ID_VALIDATION: "ID ਦਾ ਪੁਸ਼ਟੀਕਰਨ",
    I_AGREE: "ਮੈਂ ਸਹਿਮਤ ਹਾਂ",
    LAST_NAME: "ਆਖਰੀ ਨਾਮ",
    LOAD_ID: "ਲੋਡ ID",
    LOAD_ID_NUMBER: "ਲੋਡ ID ਨੰਬਰ",
    OUTBOUND_BOL: "ਆਊਟਬਾਉਂਡ BOL",
    PHONE_NUMBER: "ਫ਼ੋਨ ਨੰਬਰ",
    PO_NUMBER: "PO ਨੰਬਰ",
    PO_NUMBER_OR_LOAD_ID: "PO ਨੰਬਰ, ASN, ਜਾਂ ਲੋਡ/ਰੈਫਰੈਂਸ ID",
    PPE_DOCK_SAFETY: "PPE ਅਤੇ ਡੌਕ ਸੁਰੱਖਿਆ",
    PPE_DOCK_SAFETY_ASSISTANCE:
      "ਜੇਕਰ ਤੁਹਾਨੂੰ ਡੌਕ ਸੁਰੱਖਿਆ ਵਿੱਚ ਸਹਾਇਤਾ ਦੀ ਲੋੜ ਹੈ ਜਾਂ PPE ਸੰਬੰਧੀ ਕੋਈ ਚਿੰਤਾਵਾਂ ਹਨ, ਤਾਂ ਕਿਰਪਾ ਕਰਕੇ ਚੈੱਕਪੁਆਇੰਟ ਸਟੇਸ਼ਨ 'ਤੇ ਨਿਯੁਕਤ ਸਟਾਫ ਨੂੰ ਮਿਲੋ।\r\nਧੰਨਵਾਦ।",
    PPE_DOCK_SAFETY_COMPLIANCE:
      "\"ਹਾਂ\" ਚੁਣ ਕੇ ਤੁਸੀਂ ਸਾਰੇ ਲਾਗੂ ਕਾਨੂੰਨਾਂ ਅਤੇ ਸਾਡੀਆਂ ਨੀਤੀਆਂ ਦੀ ਪਾਲਣਾ ਕਰਨ ਲਈ ਸਹਿਮਤ ਹੁੰਦੇ ਹੋ। ਅਣਅਧਿਕਾਰਤ ਵਰਤੋਂ, ਸੋਧ, ਜਾਂ ਵੰਡ ਦੀ ਮਨਾਹੀ ਹੈ। ਅਸੀਂ ਕਿਸੇ ਵੀ ਨੁਕਸਾਨ ਲਈ ਜ਼ਿੰਮੇਵਾਰ ਨਹੀਂ ਹਾਂ। ਹੋਰ ਜਾਣਕਾਰੀ ਲਈ, ਸਾਡੀ ਪ੍ਰਾਈਵੇਸੀ ਪੋਲਿਸੀ ਅਤੇ ਪੂਰੀਆਂ ਸ਼ਰਤਾਂ  ਵੇਖੋ।\r\nਡੌਕ ਸੁਰੱਖਿਆ ਜਾਂ PPE ਜ਼ਰੂਰਤਾਂ ਦੀ ਪਾਲਣਾ ਕਰਨ ਵਿੱਚ ਅਸਫਲ ਰਹਿਣ 'ਤੇ ਜੁਰਮਾਨਾ ਹੋ ਸਕਦਾ ਹੈ। ਜੇਕਰ ਤੁਹਾਨੂੰ ਡੌਕ ਸੁਰੱਖਿਆ ਵਿੱਚ ਸਹਾਇਤਾ ਦੀ ਲੋੜ ਹੈ ਜਾਂ PPE ਸੰਬੰਧੀ ਕੋਈ ਚਿੰਤਾਵਾਂ ਹਨ, ਤਾਂ ਕਿਰਪਾ ਕਰਕੇ ਚੈੱਕਪੁਆਇੰਟ ਸਟੇਸ਼ਨ 'ਤੇ ਨਿਯੁਕਤ ਸਟਾਫ ਨੂੰ ਮਿਲੋ।",
    REASON_FOR_ENTRY: "ਐਂਟਰੀ ਦਾ ਕਾਰਨ",
    REEFER_FUEL_LEVEL: "ਰੀਫਰ ਫਿਊਲ ਲੈਵਲ",
    REEFER_ON: "ਰੀਫਰ ਚਾਲੂ/ਬੰਦ",
    SEAL_NUMBER: "ਸੀਲ ਨੰਬਰ",
    SEARCH_CARRIER: "ਇੱਕ ਕੈਰੀਅਰ ਖੋਜੋ...",
    SELECT_FACILITY: "ਸੁਵਿਧਾ ਚੁਣੋ...",
    SELECT_X: "{{X}} ਚੁਣੋ",
    SIGNATURE: "ਦਸਤਖਤ",
    TEMPERATURE_F: "ਤਾਪਮਾਨ (°F)",
    TRACTOR_CARRIER_NAME: "ਟਰੈਕਟਰ ਕੈਰੀਅਰ ਦਾ ਨਾਮ",
    TRACTOR_NUMBER: "ਟਰੈਕਟਰ ਦਾ ਨੰਬਰ",
    TRAILER_CARRIER_NAME: "ਟ੍ਰੇਲਰ ਕੈਰੀਅਰ ਦਾ ਨਾਮ",
    TRAILER_MIDDLE: "ਵਿਚਕਾਰਲਾ",
    TRAILER_NOSE: "ਨੱਕ",
    TRAILER_NUMBER: "ਟ੍ਰੇਲਰ ਨੰਬਰ",
    TRAILER_TAIL: "ਪੂਛ",
    TRAILER_TYPE: "ਟ੍ਰੇਲਰ ਦੀ ਕਿਸਮ",
    VALIDATION_PERIOD: "ਪੁਸ਼ਟੀਕਰਨ ਦੀ ਮਿਆਦ",
  },
  QUESTION: {
    ACTUAL_TEMPERATURE_F: "ਅਸਲ ਤਾਪਮਾਨ °F",
    APPOINTMENT_DETAILS: "ਅਪੌਇੰਟਮੈਂਟ ਦੇ ਵੇਰਵੇ",
    COMPANY_INFO: "ਕੰਪਨੀ ਦੀ ਜਾਣਕਾਰੀ",
    CONFIRM_SEAL_AND_TRAILER_NUMBER: "ਪੁਸ਼ਟੀ ਕਰੋ ਕਿ ਸੀਲ ਠੀਕ ਹੈ ਅਤੇ ਟ੍ਰੇਲਰ ਨੰਬਰ ਸਹੀ ਹੈ।",
    CONFIRM_TRAILER_CONDITION:
      "ਪੁਸ਼ਟੀ ਕਰੋ ਕਿ ਟ੍ਰੇਲਰ 'ਤੇ ਕੋਈ ਮਲਬਾ ਨਹੀਂ ਹੈ, ਟੈਂਡਮ ਪਿੱਛੇ ਖਿਸਕੇ ਹੋਏ ਹਨ, ਅਤੇ ਰੀਫਰ ਕੰਮ ਕਰ ਰਿਹਾ ਹੈ।",
    DRIVER_NAME: "ਡਰਾਈਵਰ ਦਾ ਨਾਮ ਦਰਜ ਕਰੋ",
    DRIVER_TYPE: "ਡਰਾਈਵਰ ਦੀ ਕਿਸਮ",
    ENTRY_PURPOSE: "ਐਂਟਰੀ ਦਾ ਉਦੇਸ਼ ਚੁਣੋ",
    ENTRY_TYPE: "ਆਪਣੀ ਐਂਟਰੀ ਦੀ ਕਿਸਮ ਚੁਣੋ",
    EQUIPMENT_DETAILS: "ਉਪਕਰਨ ਦੇ ਵੇਰਵੇ",
    GENERIC: "ਜਾਣਕਾਰੀ ਭਰੋ",
    LOAD_DETAILS: "ਵੇਰਵੇ ਲੋਡ ਕਰੋ",
    LOAD_TYPE: "ਲੋਡ ਦੀ ਕਿਸਮ ਚੁਣੋ",
    PERSONAL_INFO: "ਨਿੱਜੀ ਜਾਣਕਾਰੀ",
    PPE_DOCK_SAFETY: "PPE ਅਤੇ ਡੌਕ ਸੁਰੱਖਿਆ",
    SET_TEMPERATURE_F: "ਤਾਪਮਾਨ °F ਵਿੱਚ ਨਿਰਧਾਰਿਤ ਕਰੋ",
    SHIPPING_DETAILS: "ਸ਼ਿਪਿੰਗ ਦੇ ਵੇਰਵੇ",
    VEHICLE_DETAILS: "ਵਾਹਨ ਦੇ ਵੇਰਵੇ",
    VISIT_TYPE: "ਆਪਣੀ ਵਿਜ਼ਿਟ ਦੀ ਕਿਸਮ ਚੁਣੋ",
    WAIVER: "ਛੂਟ",
  },
  STATUS: {
    ACTIVE: "ਕਿਰਿਆਸ਼ੀਲ",
    EXPIRED: "ਸਮਾਪਤ ਹੋ ਚੁੱਕੀ ਹੈ",
    EXPIRING_SOON: "ਜਲਦੀ ਹੀ ਸਮਾਪਤ ਹੋਣ ਵਾਲੀ ਹੈ",
  },
  SUCCESS_PAGE: {
    COMMAND: {
      DOWNLOAD: "ਡਾਊਨਲੋਡ ਕਰੋ",
      EMAIL: "ਈਮੇਲ",
      HOME: "ਘਰ",
      MESSAGE: "ਸੁਨੇਹਾ",
      START_OVER: "ਮੁੜ ਸ਼ੁਰੂ ਕਰੋ",
    },
    DRIVER_CHECK_IN_SUCCESS: "ਚੈੱਕ-ਇਨ ਸਫਲਤਾਪੂਰਵਕ ਸ਼ੁਰੂ ਹੋ ਗਿਆ ਹੈ",
    DRIVER_CHECK_OUT_SUCCESS: "ਚੈੱਕ-ਆਊਟ ਸਫਲਤਾਪੂਰਵਕ ਸ਼ੁਰੂ ਹੋ ਗਿਆ ਹੈ",
    GENERATING_QR_CODE: "QR ਕੋਡ ਤਿਆਰ ਹੋ ਰਿਹਾ ਹੈ!",
    PLEASE_CHECK_DASHBOARD: "ਸਥਿਤੀ ਲਈ AVAC ਡੈਸ਼ਬੋਰਡ ਦੀ ਜਾਂਚ ਕਰੋ।",
    PLEASE_SCAN_CODE: "ਕਿਰਪਾ ਕਰਕੇ ਕਿਓਸਕ 'ਤੇ ਆਪਣਾ QR ਕੋਡ ਸਕੈਨ ਕਰੋ।",
    PLEASE_WAIT: "ਕਿਰਪਾ ਕਰਕੇ ਉਡੀਕ ਕਰੋ...",
    QR_CODE_GENERATED: "QR ਕੋਡ ਤਿਆਰ ਹੋ ਗਿਆ ਹੈ!",
  },
  SUGGESTION: {
    PO_NUMBER_OR_LOAD_ID: "PO ਨੰਬਰ ਜਾਂ ID ਫੀਲਡ ਲੋਡ ਦਰਜ ਕਰੋ।",
  },
  TITLE: {
    CARRIER: "ਕੈਰੀਅਰ",
    CATEGORY: "ਸ਼੍ਰੇਣੀ",
    COMPANY_NAME: "ਕੰਪਨੀ ਦਾ ਨਾਮ",
    EMAIL_ADDRESS: "ਈਮੇਲ ਪਤਾ",
    ENTRY_SUB_TYPE: "ਐਂਟਰੀ ਦੀ ਉਪ-ਕਿਸਮ",
    ENTRY_TYPE: "ਐਂਟਰੀ ਦੀ ਕਿਸਮ",
    FIRST_NAME: "ਪਹਿਲਾ ਨਾਮ",
    LAST_NAME: "ਆਖਰੀ ਨਾਮ",
    PHONE_NUMBER: "ਫ਼ੋਨ ਨੰਬਰ",
    REASON_FOR_ENTRY: "ਐਂਟਰੀ ਦਾ ਕਾਰਨ",
    REFERENCE_NUMBER: "ਹਵਾਲਾ ਨੰਬਰ",
    SEAL_NUMBER: "ਸੀਲ ਨੰਬਰ",
    SIGNATURE: "ਦਸਤਖਤ",
    TEMPERATURE: "ਤਾਪਮਾਨ",
    TRAILER_NUMBER: "ਟ੍ਰੇਲਰ ਨੰਬਰ",
    VALIDATION_PERIOD: "ਪੁਸ਼ਟੀਕਰਨ ਦੀ ਅਵਧੀ",
  },
  TOOLTIP: {
    ADD: "ਸ਼ਾਮਲ ਕਰੋ",
    ARROW: "ਤੀਰ",
    COMPANY_LOGO: "ਕੰਪਨੀ ਦਾ ਲੋਗੋ",
    DOWNLOAD: "ਡਾਊਨਲੋਡ ਕਰੋ",
    LOGO: "ਲੋਗੋ",
    MENU: "ਮੀਨੂ",
    SORT_ASC: "ਚੜਦੇ ਕ੍ਰਮ ਵਿੱਚ ਛਾਂਟੋ",
    SORT_DESC: "ਘਟਦੇ ਕ੍ਰਮ ਵਿੱਚ ਛਾਂਟੋ",
  },
  VALIDATION: {
    EMAIL_ADDRESS: "ਕਿਰਪਾ ਕਰਕੇ ਇੱਕ ਵੈਧ ਈਮੇਲ ਪਤਾ ਦਰਜ ਕਰੋ",
    ERROR: {
      BOL_VALIDATION_FAILED: "ਹਵਾਲਾ ਨੰਬਰ ਦੀ ਪੁਸ਼ਟੀ ਕਰਨ ਵਿੱਚ ਅਸਫਲ।",
      FUEL_VALIDATION_FAILED: "ਰੀਫਰ ਅੰਕੜੇ ਪ੍ਰਾਪਤ ਕਰਨ ਵਿੱਚ ਅਸਫਲ",
      INVALID_BOOKING_NUMBER: "ਅਵੈਧ ਬੁਕਿੰਗ ਨੰਬਰ",
      INVALID_FACILITY: "ਅਵੈਧ ਸਹੂਲਤ",
      INVALID_LOAD_ID: "ਅਵੈਧ ਲੋਡ ID",
      LOAD_ID_VALIDATION_FAILED: "ਲੋਡ ID ਨੰਬਰ ਦਾ ਪੁਸ਼ਟੀਕਰਨ ਅਸਫਲ ਰਿਹਾ।",
      PO_VALIDATION_FAILED: "ਅਵੈਧ PO। ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ ਜਾਂ ਇਨਬਾਊਂਡ ਕਲਰਕ ਨੂੰ ਮਿਲੋ।",
      TRAILER_VALIDATION_FAILED: "ਟ੍ਰੇਲਰ ਵੇਰਵਿਆਂ ਦੀ ਪੁਸ਼ਟੀ ਕਰਨ ਵਿੱਚ ਅਸਫਲ ਰਿਹਾ।",
    },
    FLOAT: "ਕਿਰਪਾ ਕਰਕੇ ਵੈਧ ਨੰਬਰ ਦਾਖਲ ਕਰੋ (ਉਦਾਹਰਨ: 123 ਜਾਂ 123.45)",
    NUMERIC: "ਕਿਰਪਾ ਕਰਕੇ ਸਿਰਫ਼ ਨੰਬਰ ਦਰਜ ਕਰੋ",
    PERSON_NAME: "ਸਿਰਫ਼ ਅੱਖਰ ਅਤੇ ਖਾਲੀ ਥਾਂਵਾਂ ਹੋਣੀਆਂ ਚਾਹੀਦੀਆਂ ਹਨ",
    PHONE_NUMBER: "ਗਲਤ ਫ਼ੋਨ ਨੰਬਰ ਫਾਰਮੈਟ",
    PO_NUMBER_OR_LOAD_ID: "ਕਿਰਪਾ ਕਰਕੇ PO ਨੰਬਰ ਜਾਂ ਲੋਡ ID ਪ੍ਰਦਾਨ ਕਰੋ",
    TEMPERATURE_FROM_N20F_TO_P100F: "ਤਾਪਮਾਨ -20°F ਅਤੇ 100°F ਦੇ ਵਿਚਕਾਰ ਹੋਣਾ ਚਾਹੀਦਾ ਹੈ।",
    VALIDATING_REFERENCE_NUMBER: "ਹਵਾਲਾ ਨੰਬਰ ਦੀ ਪੁਸ਼ਟੀ ਕੀਤੀ ਜਾ ਰਹੀ ਹੈ",
    VALIDATING_TRAILER_DETAILS: "ਟ੍ਰੇਲਰ ਵੇਰਵਿਆਂ ਦੀ ਪੁਸ਼ਟੀ ਕੀਤੀ ਜਾ ਰਹੀ ਹੈ।",
  },
} as const;
